module.exports = __webpack_public_path__ + "img/hualongqu.e4f3c9e6.png";